import VParallax from './VParallax';
export { VParallax };
export default VParallax;
//# sourceMappingURL=index.js.map